import { useLocation, useNavigate, useParams } from "react-router-dom"
import { ChevronLeft } from "lucide-react"
import { Invoice, LightBtn, PageHeader } from "../../common/ui"
import {
  useFetchOrgDetailsQuery,
  useFetchOrgsSystemUsageQuery
} from "../../redux/queries"
import { RequireRole } from "../../common/validation"
import { ALLOWED_ROLES_BY_ROUTE } from "../../common/constants"
import { BillingLog, Organization } from "../../types"

let month = ""

const BillingInvoice = () => {
  const { _id = "" } = useParams<{ _id: string }>()

  const location = useLocation()
  const { usage, org }: { usage?: BillingLog; org?: Organization } =
    location.state || {}

  const { data: orgFetched } = useFetchOrgDetailsQuery(
    { id: _id ?? "" },
    { skip: !org || !_id }
  )

  const orgDetails = org || orgFetched

  // Fetch system usage for each org
  const {
    data: fetchedData = {},
    isFetching: isFetchingUsage,
    isError: isErrorUsage
  } = useFetchOrgsSystemUsageQuery(
    { orgs: [{ id: _id }], month },
    { skip: !_id || !usage }
  )

  const systemUsageData = usage || fetchedData[_id]?.[0]

  const navigate = useNavigate()

  const onClickBack = () => {
    navigate("/billing")
  }

  return (
    <RequireRole allowedRoles={ALLOWED_ROLES_BY_ROUTE.billing}>
      <>
        <div className="p-6 pt-4 sm:pt-6 border-neutral-200">
          <PageHeader title={`Billing: ${orgDetails?.name}`}>
            <LightBtn onClick={onClickBack} text="base" size="sm">
              <ChevronLeft size={16} />{" "}
              <span className="inline-block px-1">Back</span>
            </LightBtn>
          </PageHeader>
        </div>
        <div className="px-4 py-6 md:px-6  flex-1 bg-primary-100">
          <div className="bg-white px-8 py-12 rounded-lg">
            <Invoice
              companyName={orgDetails?.name ?? ""}
              invoiceTimestamp={systemUsageData.timestamp}
              usage={systemUsageData.details}
            />
          </div>
        </div>
      </>
    </RequireRole>
  )
}

export default BillingInvoice
